import buildAuthorization from 'common/utils/buildAuthorization';

import { UserSelector } from 'redux/selectors/UserSelector';

import {
    FETCH_BOOK_ORDER_LIST,
    CREATE_BOOK_ORDER
} from 'redux/actions/actionTypes';
import { BOOK_ORDER_URL } from 'common/constant';

export const fetch = (options = {}) => (dispatch, getState) => {
    const user = UserSelector(getState());
    const url = BOOK_ORDER_URL;
    const auth = buildAuthorization(user);

    return dispatch({
        type: FETCH_BOOK_ORDER_LIST,
        payload: {
            request: {
                url,
                method: 'GET',
                params: options,
                headers: {
                    Authorization: auth
                }
            }
        }
    });
};

export const create = (data, options = {}) => (dispatch, getState) => {
    const user = UserSelector(getState());
    const url = BOOK_ORDER_URL;
    const auth = buildAuthorization(user);

    return dispatch({
        type: CREATE_BOOK_ORDER,
        payload: {
            request: {
                url,
                method: 'POST',
                data,
                headers: {
                    Authorization: auth
                }
            }
        }
    });
};
